import React, { Component } from 'react'
import RefSelect from './RefSelect';
import Modal from '../elements/Modal/Modal'
import { getSuppliers } from '../api/resources/Suppliers'
import CreateSupplierForm from './Suppliers/CreateSupplierForm';
import { Typography } from '@material-ui/core';

export default class SupplierSelect extends Component {

  constructor(props) {
    super(props)
    this.state = {
      suppliers: [],
      selected: this.props.initialValue,
      showModal: false,
    }
    this.newSupplierModal = this.newSupplierModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleCreateSupplier = this.handleCreateSupplier.bind(this)
  }

  openModal() {
    this.setState({showModal: true})
  }

  closeModal() {
    this.setState({showModal: false})
  }

  componentDidMount() {
    getSuppliers().then(suppliers => this.setState({ suppliers, selected: this.props.initialValue}) )
  }

  handleCreateSupplier(newSupplier) {
    this.setState({
      suppliers: [
        ...this.state.suppliers,
        newSupplier
      ],
      selected: newSupplier
    });
    this.props.onUpdate(newSupplier)
    this.closeModal();
  }

  newSupplierModal() {
    this.openModal();
  }

  render() {

    const { onUpdate, error } = this.props;
    const { selected, suppliers, showModal } = this.state;

    return (
      <>
        { suppliers && <RefSelect
          options={suppliers}
          initialValue={selected}
          onUpdate={onUpdate}
          error={error}
          label='Supplier'
          onCreate={this.newSupplierModal}
        /> }
        <Modal show={showModal} onClose={this.closeModal}>
          <div style={{width: '400px'}}>
            <Typography variant='h6'>Add new supplier</Typography>
            <CreateSupplierForm
              isEditing={true}
              onCreate={this.handleCreateSupplier} />
          </div>
        </Modal>
      </>
    )
    
  }
}